export function purchasePathEvents() {
    const allow = window.Didomi.getUserConsentStatusForVendor('google')
    console.debug(`Custom GTAG purchase events: ga.js (allowed: ${allow})`);

    // const urlParams = new URLSearchParams(window.location.search)
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}

    var step, stepName;
    if(location.pathname == '/accounts/login/') [step, stepName] = [1, 'user_login']
    if(location.pathname == '/accounts/create/') [step, stepName] = [1, 'user_create']
    if(location.pathname.startsWith('/store/order/create/')) [step, stepName] = [2, 'order_create']
    if(location.pathname.match(/^\/store\/order\/\d+\/upn\/$/)) [step, stepName] = [4, 'order_proforma']
    if(location.pathname.startsWith('/store/order/checkout/')) [step, stepName] = [3, 'order_payment_method']
    if(location.pathname.startsWith('/store/order/end/')) [step, stepName] = [4, 'order_purchase']

    if(!step) return
    
    const payload = {step, stepName, path: window.location.pathname, date: (new Date()).toString()}
    gtag('event', 'custom_step_'+stepName, payload);
    console.debug(`Custom GTAG purchase_step event sent:`, 'custom_step_'+stepName, payload);
}

